module.exports = __webpack_public_path__ + "static/media/cv_icon.782514cf.png";